module.exports = __webpack_public_path__ + "static/img/17.d52c3d0.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/9/1/1/sp/17.png
// module id = PvjQ
// module chunks = 0